import Vue from 'vue'
import Vuex from 'vuex'
import { vuexfireMutations, firestoreAction } from 'vuexfire'
import { publicDeck } from './publicDeck'
import { draftDeck } from './draftDeck'
import { deckDetail } from './deckDetail'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activeTabId: 'public'
  },
  mutations: {

  },
  actions: {

  },
  getters: {

  },
  modules: {
    publicDeck,
    draftDeck,
    deckDetail
  }
})
